import type { CSSProperties, FC } from 'react';
import { useState } from 'react';
import classNames from 'classnames';

import { useOverTimeout } from 'app/hooks/useTimeout';

import style from './style.module.scss';

const COUNTRY_MAP: Record<string, string> = {
  en: 'us',
  uk: 'ua',
  sv: 'se'
};

interface Props extends ClassNameProp {
  country: string | null;
  size?: number;
  style?: CSSProperties;
}

const CountryFlag: FC<Props> = ({ country, size = 20, className, style: css }) => {
  const [status, setStatus] = useState<'loading' | 'succeed' | 'failed'>('loading');
  const loadOvertime = useOverTimeout(100);
  const handleSuccess = () => {
    setStatus('succeed');
  };
  const handleError = () => {
    setStatus('failed');
  };

  if (!country) {
    return null;
  }

  const imageUrl = `${import.meta.env.BASE_URL}flags/${COUNTRY_MAP[country] ?? country}.svg`;

  const fontSize = Math.floor(size / 2) - 1;
  const containerStyle = { width: size, height: size, fontSize, ...css };
  const imageClassName = classNames(style.image, {
    [style.image_loading]: loadOvertime && status === 'loading'
  });

  return (
    <div className={classNames(style.container, className)} style={containerStyle}>
      {status !== 'failed' ? (
        <img
          className={imageClassName}
          src={imageUrl}
          alt={country}
          onLoad={handleSuccess}
          onError={handleError}
        />
      ) : (
        <div className={style.fallback} title={country}>
          {country}
        </div>
      )}
    </div>
  );
};

CountryFlag.displayName = 'CountryFlag';

export default CountryFlag;
